import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateStatusComponent } from './marketdate-status.component';
import { MarketdateStatusDetailComponent } from './marketdate-status-detail.component';
import { MarketdateStatusPopupComponent } from './marketdate-status-dialog.component';
import { MarketdateStatusDeletePopupComponent } from './marketdate-status-delete-dialog.component';

import { Principal } from '../../shared';

export const marketdateStatusRoute: Routes = [
  {
    path: 'marketdate-status',
    component: MarketdateStatusComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate-status/:id',
    component: MarketdateStatusDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdateStatusPopupRoute: Routes = [
  {
    path: 'marketdate-status-new',
    component: MarketdateStatusPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-status/:id/edit',
    component: MarketdateStatusPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-status/:id/delete',
    component: MarketdateStatusDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateStatus.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status.route.ts